const r = {
  name: "UnknownCountries",
  dimensions: { width: 22, height: 23 },
  content: `
        <g>
            <path fill="none" stroke="currentColor" d="M11 21.75C16.5228 21.75 21 17.2728 21 11.75C21 6.22715 16.5228 1.75 11 1.75C5.47715 1.75 1 6.22715 1 11.75C1 17.2728 5.47715 21.75 11 21.75Z" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <circle fill="currentColor" stroke="none" cx="18" cy="6.75" r="1" />
            <circle fill="currentColor" stroke="none" cx="18" cy="9.75" r="1" />
            <circle fill="currentColor" stroke="none" cx="18" cy="12.75" r="1" />
            <circle fill="currentColor" stroke="none" cx="18" cy="15.75" r="1" />
            <circle fill="currentColor" stroke="none" cx="15" cy="4.75" r="1" />
            <circle fill="currentColor" stroke="none" cx="15" cy="7.75" r="1" />
            <circle fill="currentColor" stroke="none" cx="15" cy="10.75" r="1" />
            <circle fill="currentColor" stroke="none" cx="15" cy="13.75" r="1" />
            <circle fill="currentColor" stroke="none" cx="15" cy="16.75" r="1" />
            <circle fill="currentColor" stroke="none" cx="15" cy="19.75" r="1" />
            <circle fill="currentColor" stroke="none" cx="12" cy="2.75" r="1" />
            <circle fill="currentColor" stroke="none" cx="12" cy="5.75" r="1" />
            <circle fill="currentColor" stroke="none" cx="9" cy="10.75" r="1" />
            <circle fill="currentColor" stroke="none" cx="12" cy="8.75" r="1" />
            <circle fill="currentColor" stroke="none" cx="9" cy="7.75" r="1" />
            <circle fill="currentColor" stroke="none" cx="12" cy="11.75" r="1" />
            <circle fill="currentColor" stroke="none" cx="6" cy="5.75" r="1" />
        </g>
   `
};
export {
  r as UnknownCountries
};
